(function(angular){
	'use strict';
	
	angular
		.module('baseCheckoutModule')
		.controller('SelectPaymentMethod', [
			'$filter',
			'$timeout',
			'$rootScope',
			'$window',
			'CheckoutFactory',
			'globalConfig',
			'mixpanelFactory',
			'PlaidFactory',
			'urlFactory',
			SelectPaymentMethodFunction
		]);
	
	function SelectPaymentMethodFunction(
		$filter,
		$timeout,
		$rootScope,
		$window,
		CheckoutFactory,
		globalConfig,
		mixpanelFactory,
		PlaidFactory,
		urlFactory
	){
		var selectPayment = this;
		var plaidLinkId = '-1';
		var enterManualId = '-2';
		var wireId = '-3';

		function successfullyLinkedPlaidAccount(linkedAccount) {
			selectPayment.selectedAccount = linkedAccount.id;
			linkPaymentToOrderAndRedirect();
		}

		function errorLinkingPlaidAccount() {
			$rootScope.ModalFactory.openDisclaimer('invalid-plaid-account-selected');
			onExitPlaidLink();
		}

		function onExitPlaidLink(onExitStatus) {
			$timeout(function() {
				if(onExitStatus === "institution_not_found") {
					selectPayment.selectedAccount = enterManualId;
					selectPayment.previousSelectedAccount = selectPayment.selectedAccount;
				}
			});
		}

		function setDefaultSelectedAccount() {
			if(selectPayment.achDisabled) {
				selectPayment.selectedAccount = wireId;
			} else if(selectPayment.activeAccounts.length > 0) {
				var primaryAccount = $filter('filter')(selectPayment.activeAccounts, {'primary': true})[0];
				selectPayment.selectedAccount = primaryAccount.value;
			} else {
				selectPayment.selectedAccount = plaidLinkId;
			}
		}

		selectPayment.handleContinue = function() {
			if(!selectPayment.disableContinue) {
				if(selectPayment.selectedAccount === plaidLinkId) {
					openPlaid();
				} else if(newAchSelected()) {
					urlFactory.redirect('/reits/checkout/new-ach-account');
				} else {
					linkPaymentToOrderAndRedirect();
				}
			}
		};

		function openPlaid() {
			selectPayment.plaidObject.open();
			mixpanelFactory.track('Plaid Link Continue Button Started');
		}

		function linkPaymentToOrderAndRedirect() {
			var redirectUrl = '/reits/checkout/select-payment-method';
			CheckoutFactory.linkPaymentToOrder(selectPayment.reitInvestmentOrderGroupId, buildPayload(), redirectUrl)
				.then(function(orderGroupId) {
					selectPayment.reitInvestmentOrderGroupId = orderGroupId;
					$timeout(function() {
						submitForm();
					});
				})
				.catch(function() {
					selectPayment.formSubmitted = false;
				});
		}

		function buildPayload() {
			var payload = {};

			if(wireSelected()) {
				payload.transactionType = 'WIRE';
			} else {
				payload.transactionType = 'ACH';
				payload.bankAccountId = selectPayment.selectedAccount;
			}

			return payload;
		}

		function newAchSelected() {
			return selectPayment.selectedAccount === enterManualId;
		}

		function wireSelected() {
			return selectPayment.selectedAccount === wireId;
		}

		function submitForm() {
			selectPayment.disableContinue = true;
			$window.document.getElementById('payment-method-form').submit();
		}

		function toggleSavingsAccount() {
			var selectedObj = $filter('filter')(selectPayment.activeAccounts, {'value': selectPayment.selectedAccount})[0];

			if(selectPayment.riaCheckout) {
				if(angular.isDefined(selectedObj) && selectedObj.type === 'SAVINGS') {
					selectPayment.disableContinue = true;
					selectPayment.showSavingsAlert = true;
					mixpanelFactory.track('Savings Account Alert Shown', {
						'Investment Count': selectPayment.numberOfInvestments
					});
				} else {
					selectPayment.disableContinue = false;
					selectPayment.showSavingsAlert = false;
				}
			}
		}

		selectPayment.changeRadio = function() {
			selectPayment.previousSelectedAccount = selectPayment.selectedAccount;
			toggleSavingsAccount();
		};

		selectPayment.wireSelected = function() {
			selectPayment.previousSelectedAccount = selectPayment.selectedAccount;
		};

		(function init(){
			angular.extend(selectPayment, globalConfig);
			if (selectPayment.achDisabled) {
				selectPayment.showAchDisabledAlert = true;
			}

			setDefaultSelectedAccount();

			selectPayment.previousSelectedAccount = selectPayment.selectedAccount;
			selectPayment.disableContinue = false;
			selectPayment.plaidObject = PlaidFactory.getPlaid(
				successfullyLinkedPlaidAccount,
				errorLinkingPlaidAccount,
				onExitPlaidLink);
			toggleSavingsAccount();

			if($window.mixpanel && angular.isDefined(selectPayment.yearOfBirth)) {
				$window.mixpanel.register_once({
					'Year of Birth' : selectPayment.yearOfBirth
				});
				$window.mixpanel.people.set_once({
					'Year of Birth' : selectPayment.yearOfBirth
				});
			}
		})();
	}
})(window.angular);